import React from 'react';
import { Card, Descriptions, Typography, Space } from 'antd';
import { showLastHeartbeat, showHeartbeatStatus, dataCenterValue } from '../utils';
import { makeNiceName } from '../../../lib/helpers';

const { Text } = Typography;

export const SourceWorkerConfiguration = ({ configuration, appliance, cardTitle, heartbeatData, error }) => {
    return configuration.map((config, index) => {
        return (
            <Card key={index} title={cardTitle} size="small">
                <Space orientation="vertical">
                    <Card title="Management" size="small" type="inner">
                        <Descriptions column={1} size="small">
                            {config.source_worker_url ? (
                                <>
                                    <Descriptions.Item label="URL">
                                        <a href={config.source_worker_url} target="_blank">
                                            {config.source_worker_url}
                                        </a>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Username">
                                        <Text>{appliance.webminUserName || 'Not available'}</Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Password">
                                        <Text>{appliance.webminPassword || 'Not available'}</Text>
                                    </Descriptions.Item>
                                </>
                            ) : (
                                <Descriptions.Item label="URL">
                                    <Text>Not Available</Text>
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </Card>
                    <Card title="Configuration" size="small" type="inner">
                        <Descriptions column={1} size="small">
                            <Descriptions.Item label="Status">
                                <Text>{showHeartbeatStatus(config?.source_worker_heartbeat)}</Text>
                            </Descriptions.Item>
                            ,
                            {error && (
                                <Descriptions.Item label="Error">
                                    <Text>
                                        "This Cloud Account information is not available at the moment. Please check if
                                        this Cloud Account still exists."
                                    </Text>
                                </Descriptions.Item>
                            )}
                            <Descriptions.Item label="Last Heartbeat">
                                <Text>{showLastHeartbeat(config?.source_worker_heartbeat)}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="VM Name">
                                <Text>{config.source_worker_vm_name}</Text>
                            </Descriptions.Item>
                            {dataCenterValue && (
                                <Descriptions.Item label="Datacenter">
                                    <Text>{dataCenterValue(config)}</Text>
                                </Descriptions.Item>
                            )}
                            <Descriptions.Item label="Cluster">
                                <Text>{config.source_worker_cluster}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="Datastore">
                                <Text>{config.source_worker_datastore}</Text>
                            </Descriptions.Item>
                            {config.source_worker_folder && (
                                <Descriptions.Item label="Folder">
                                    <Text>{config.source_worker_folder}</Text>
                                </Descriptions.Item>
                            )}
                            {config.source_worker_resource_pool && (
                                <Descriptions.Item label="Resource Pool">
                                    <Text>{config.source_worker_resource_pool}</Text>
                                </Descriptions.Item>
                            )}
                            <Descriptions.Item label="Network">
                                <Text>{config.source_worker_network}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="IP Type">
                                <Text>{makeNiceName(config.source_worker_ip_type, true)}</Text>
                            </Descriptions.Item>
                            {!!config.source_worker_ip && (
                                <Descriptions.Item label="IP">
                                    <Text>{config.source_worker_ip}</Text>
                                </Descriptions.Item>
                            )}
                            {!!config.source_worker_netmask && (
                                <Descriptions.Item label="Netmask">
                                    <Text>{config.source_worker_netmask}</Text>
                                </Descriptions.Item>
                            )}
                            {!!config.source_worker_gateway && (
                                <Descriptions.Item label="Gateway">
                                    <Text>{config.source_worker_gateway}</Text>
                                </Descriptions.Item>
                            )}
                            <Descriptions.Item label="DNS1">
                                <Text>{config.source_worker_dns1}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="DNS2">
                                <Text>{config.source_worker_dns2}</Text>
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Space>
            </Card>
        );
    });
};
